import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IClientLogo, IClientLogoInitialState } from "./clientLogoModel";
import {
  ActiveInactiveClientLogo,
  ClientLogoImageUpload,
  createClientLogo,
  deleteClientLogo,
  getAllActiveClientLogos,
  getAllClientLogos,
  getClientLogoByID,
  updateClientLogo,
} from "./services/clientLogo.services";

const initialState: IClientLogoInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ClientLogoID: null,
  ClientLogoList: [],
  ClientLogoDetail: {
    ClientName: "",
    Logo: "",
    IsActive: 1,
  },
};

const clientLogoSlice = createSlice({
  name: "clientLogo",
  initialState,
  reducers: {
    clearClientLogoDetails: (state) => {
      state.ClientLogoDetail = initialState.ClientLogoDetail;
    },
    setClientLogoID: (state, action) => {
      state.ClientLogoID = action.payload;
    },
    clearClientLogoID: (state) => {
      state.ClientLogoID = initialState.ClientLogoID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllClientLogos.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllClientLogos.fulfilled,
      (state, action: PayloadAction<IClientLogo[]>) => {
        state.loading = false;
        state.ClientLogoList = action.payload || [];
      }
    );
    builder.addCase(getAllClientLogos.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ClientLogoList = [];
    });
    builder.addCase(createClientLogo.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createClientLogo.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createClientLogo.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateClientLogo.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateClientLogo.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateClientLogo.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteClientLogo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteClientLogo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteClientLogo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getClientLogoByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getClientLogoByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ClientLogoDetail = action.payload;
    });
    builder.addCase(getClientLogoByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ClientLogoDetail = initialState.ClientLogoDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveClientLogos.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveClientLogos.fulfilled,
      (state, action: PayloadAction<IClientLogo[]>) => {
        state.loading = false;
        state.ClientLogoList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveClientLogos.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ClientLogoList = [];
    });
    builder.addCase(ActiveInactiveClientLogo.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveClientLogo.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveClientLogo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(ClientLogoImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ClientLogoImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ClientLogoImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearClientLogoDetails, clearClientLogoID, setClientLogoID } =
  clientLogoSlice.actions;
export default clientLogoSlice.reducer;
